import React from 'react';
import { Form, Row } from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { useForm } from 'react-hook-form';
import { Text } from 'components/Form/Fields';
import { SelectWihoutControl } from 'components/Form/Fields';
import { STATES_BRAZIL } from 'utility/data-offiline';

const toRedirect = '/admin/city/';

export const FormCity = () => {
  const { reset, getValues, control, setValue, watch } = useForm({
    defaultValues: {
      id: null,
      name: '',
      state: '',
    },
  });

  const handleLoadCitiesByState = async (e) => {
    const rawState = e.target.value;
    setValue('state', rawState);
  };

  return (
    <>
      <CustomForm
        nameForm={'Cadastro de Cidade'}
        typeForm={'POST'}
        pathUrl={'/v1/city'}
        toRedirect={toRedirect}
        getValues={getValues}
        loadValues={reset}
        forceRefreshPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <SelectWihoutControl
                label={'Estado'}
                size={2}
                data={STATES_BRAZIL}
                onChange={handleLoadCitiesByState}
                value={watch('state')}
              />
              <Text
                control={control}
                label={'Nome da Cidade'}
                fieldName={'name'}
                placeholder={'Informe o nome do produto'}
                size={3}
              />
            </Row>
          </div>
        </Form>
      </CustomForm>
    </>
  );
};
